
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MediaMosaicEffect extends BaseParallaxEffect implements ParallaxEffect {
    private imageCache: Map<string, HTMLImageElement> = new Map();
    private static videoCache: Map<string, HTMLVideoElement> = new Map();

    public render(pc: ParallaxContext): void {
        const { ctx, config, width, height, time, layerIndex } = pc;
        const imageUrl = config.parallaxImageUrl;
        const videoUrl = config.parallaxVideoUrl;
        
        let img: HTMLImageElement | null = null;
        if (imageUrl) {
            img = this.imageCache.get(imageUrl) || null;
            if (!img) {
                img = new Image();
                img.src = imageUrl;
                img.referrerPolicy = "no-referrer";
                this.imageCache.set(imageUrl, img);
            }
        }

        let video: HTMLVideoElement | null = null;
        if (videoUrl) {
            video = MediaMosaicEffect.videoCache.get(videoUrl) || null;
            if (!video) {
                video = document.createElement('video');
                video.src = videoUrl;
                video.loop = true; video.muted = true;
                video.play().catch(() => {});
                MediaMosaicEffect.videoCache.set(videoUrl, video);
            }
        }

        const size = (100 + layerIndex * 50) * (config.parallaxScale || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, size);

        ctx.save();
        ctx.globalAlpha *= (config.parallaxMediaOpacity || 1.0);

        for (let x = x1; x <= x2; x += size) {
            for (let y = y1; y <= y2; y += size) {
                const useVideo = (this.pseudoRandom(x + y) > 0.5) && video && video.readyState >= 2;
                if (useVideo && video) {
                    ctx.drawImage(video, x, y, size * 0.95, size * 0.95);
                } else if (img && img.complete) {
                    ctx.drawImage(img, x, y, size * 0.95, size * 0.95);
                } else {
                    ctx.fillStyle = pc.color;
                    ctx.fillRect(x, y, size * 0.95, size * 0.95);
                }
            }
        }
        ctx.restore();
    }
}
